import React from "react";
import { Link } from "react-router-dom";

import { properties } from "./data";
import { MdElectricBolt, MdWaterDrop, MdWifi } from "react-icons/md";
import { GiBrickWall } from "react-icons/gi";
import { CgTrees } from "react-icons/cg";

export default function Property() {
  // Sort by priority (descending), then take top 6
  const featured = [...properties]
    .sort((a, b) => (b.priority || 0) - (a.priority || 0))
    .slice(0, 6);

  return (
    <>
      <div className="container lg:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-8 text-center">
          <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">
            Featured Properties
          </h3>

          <p className="text-slate-400 max-w-xl mx-auto">
            A great plateform to buy, sell and rent your properties without any
            agent or commisions.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-8 gap-[30px]">
          {featured.map((item, index) => (
            <div
              className="group rounded-xl bg-white dark:bg-slate-900 shadow hover:shadow-xl dark:hover:shadow-xl dark:shadow-gray-700 dark:hover:shadow-gray-700 overflow-hidden ease-in-out duration-500"
              key={index}
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.name || "Property listing"}
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  width="400"
                  height="300"
                />

                <div className="absolute top-4 end-4">
                  <Link
                    to="#"
                    className="btn btn-icon bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-full text-slate-100 dark:text-slate-700 focus:text-red-600 dark:focus:text-red-600 hover:text-red-600 dark:hover:text-red-600"
                  >
                    <i className="mdi mdi-heart mdi-18px"></i>
                  </Link>
                </div>
              </div>

              <div className="p-6">
                <div className="pb-6">
                  <Link
                    to={`/property-detail/${item.id}`}
                    className="text-lg hover:text-slate-700 font-medium ease-in-out duration-500"
                  >
                    {item.name}
                  </Link>
                </div>

                <ul className="py-6 border-y border-slate-100 dark:border-gray-800 flex items-center list-none">
                  <li className="flex items-center me-4">
                    <CgTrees className="text-2xl me-2 text-slate-700" />
                    <span>Acres: {item.acres}</span>
                  </li>
                  <li className="flex items-center me-4">
                    <MdElectricBolt className="text-2xl me-2 text-slate-700" />
                    <span>Electric: {item.electric ? "Yes" : "No"}</span>
                  </li>
                  <li className="flex items-center me-4">
                    <MdWaterDrop className="text-2xl me-2 text-slate-700" />
                    <span>Water: {item.water ? "Yes" : "No"}</span>
                  </li>
                </ul>

                <ul className="md:pt-4 pt-6 flex justify-between items-center list-none gap-2 min-w-0">
                  <li className="shrink-0 min-w-0">
                    <span className="text-slate-400">Price</span>
                    <p
                      className="text-base font-medium max-w-[100px] truncate"
                      title={item.price}
                    >
                      <Link
                        to="/contact"
                        className="text-slate-700 hover:text-slate-700 transition-colors duration-200"
                      >
                        Call to Ask
                      </Link>
                    </p>
                  </li>
                  <li className="flex items-center me-4">
                    <MdWifi className="text-2xl me-2 text-slate-700" />
                    <span>Internet: {item.internet ? "Yes" : "No"}</span>
                  </li>
                  <li className="flex items-center">
                    <GiBrickWall className="text-2xl me-2 text-slate-700" />
                    <span>Buildsites: {item.buildsites}</span>
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
